import React from 'react';
import { ProgressBarContainer, ProgressBarSegment } from './styled';

/**
 * SuccessFailureProgressBar component displays a progress bar indicating the success and failure percentages.
 *
 * @param {Object} props - The component props.
 * @param {number|string} props.sucesso - The number of successful cases.
 * @param {number|string} props.insucesso - The number of failed cases.
 * @param {number|string} props.count - The total number of cases.
 * @returns {JSX.Element} The rendered component.
 */
const SuccessFailureProgressBar = ({ sucesso, insucesso, count }) => {
  const countNum = Number(count);
  if (countNum === 0) return <div>Nenhum dado disponível.</div>;

  const successVal = Number(sucesso);
  const failureVal = Number(insucesso);
  const successPercentage = (successVal / countNum) * 100;
  const failurePercentage = (failureVal / countNum) * 100;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginBottom: '10px',
        textAlign: 'center'
      }}
    >
      <span>{(successPercentage + failurePercentage).toFixed(2)}%</span>
      <ProgressBarContainer>
        <ProgressBarSegment
          percentage={successPercentage}
          color="#2dce89"
          offset={0}
          title={`Sucesso: ${sucesso} (${successPercentage.toFixed(2)}%)`}
        />
        <ProgressBarSegment
          percentage={failurePercentage}
          color="#f5365c"
          offset={successPercentage}
          title={`Insucesso: ${insucesso} (${failurePercentage.toFixed(2)}%)`}
        />
      </ProgressBarContainer>
    </div>
  );
};

export default SuccessFailureProgressBar;
